import React from 'react';
import { DataThreeSvg } from 'src/assets/dynamicSvg';
import { Poppins } from './Poppins';
import * as S from './EmptyState.styles';

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  /** Defaults to the app's chart glyph; pass another when it names the thing that is missing. */
  icon?: React.ReactNode;
  /** Drops the card's border and radius, for a slot that already has one. */
  bare?: boolean;
  minHeight?: number;
  dataCy?: string;
}

/**
 * The app's empty state: a centred glyph, a line saying what belongs here, and a line saying how
 * it gets here.
 *
 * Extracted from riskIntel's `EmptyStateCard`, which was this exact block with its copy baked in.
 * Reach for it instead of a bare sentence: an empty slot with one line of prose in it reads as a
 * rendering failure, and a red one reads as an error even when nothing has gone wrong.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  bare,
  minHeight = 308,
  dataCy,
}) => (
  <S.Card $bare={bare} $minHeight={minHeight} data-cy={dataCy}>
    <S.Col>
      {icon ?? <DataThreeSvg size={64} />}
      <Poppins px={16} weight={600} color="cflowerBlue">
        {title}
      </Poppins>
      {description ? (
        <S.Description px={16} color="cflowerBlue">
          {description}
        </S.Description>
      ) : null}
    </S.Col>
  </S.Card>
);
